import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SatPopoverModule} from '@ncstate/sat-popover';
import {HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxMaskModule} from 'ngx-mask';
import {NgSelectModule} from '@ng-select/ng-select';
import {OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {CommonModule} from '@angular/common';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {ResizableModule} from 'angular-resizable-element';
import {MapWidgetComponent} from './map-widget/map-widget.component';
import {_} from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import {TimeagoFormatter, TimeagoIntl, TimeagoModule} from 'ngx-timeago';
import {TimeAgoIntlRu} from './TimeAgoIntlRu';
import {TimeagoCustomFormatter} from './TimeagoCustomFormatter';
import {TimeAgoIntlEn} from './TimeAgoIntlEn';
import {LightboxModule} from 'ngx-lightbox';
import {RouterModule} from '@angular/router';
import {HeaderWithIconComponent} from './header-with-icon/header-with-icon.component';
import {PreloaderComponent} from './preloader/preloader.component';
import {DateIntervalSelectionComponent} from './date-interval-selection/date-interval-selection.component';
import {HorizontalStackedBarChartComponent} from './horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.component';
import {DotLegendComponent} from './dot-legend/dot-legend.component';
import {HorizontalItemSelectionComponent} from './horizontal-item-selection/horizontal-item-selection.component';
import {OutsideClickDirective} from './outside-click.directive';
import {ModalWindowConfirmationComponent} from './modal-window/modal-window/modal-window-confirmation/modal-window-confirmation.component';
import {ModalWindowSelectionComponent} from './modal-window/modal-window/modal-window-selection/modal-window-selection.component';
import {ModalWindowChecklistComponent} from './modal-window/modal-window/modal-window-checklist/modal-window-checklist.component';
import {TooltipDirective} from './tooltip.directive';
import {UserSelectionComponent} from './user-selection/user-selection.component';
import {ModalWindowQrcodeSizeComponent} from './modal-window/modal-window/modal-window-qrcode-size/modal-window-qrcode-size.component';
import {DateIntervalComponent} from '../statistic/date-interval/date-interval.component';
import {LeafletInfoControlComponent} from './leaflet/leaflet-info-control/leaflet-info-control.component';
import {
  LeafletMarkerGroupingToggleControlComponent
} from './leaflet/leaflet-marker-grouping-toggle-control/leaflet-marker-grouping-toggle-control.component';
import {
  ModalWindowButtonSelectionComponent
} from './modal-window/modal-window/modal-window-button-selection/modal-window-button-selection.component';
import {ModalWindowLowBalanceComponent} from './modal-window/modal-window/modal-window-low-balance/modal-window-low-balance.component';
import {DefaultIntl} from './DefaultIntl';
import {LeafletRegionsControlComponent} from './leaflet/leaflet-regions-control/leaflet-regions-control.component';
import {MapSettingsComponent} from '../map-settings/map-settings.component';
import {MapServicesComponent} from '../map-settings/map-services/map-services.component';
import {TranslationSelectorService} from './translation-selector.service';
import {GeoitemToggleComponent} from '../dashboard/monitoring/geoitem-toggle/geoitem-toggle.component';
import {
  DashboardLayersGeoControlComponent
} from '../dashboard/monitoring/dashboard-layers-control/dashboard-layers-geo-control/dashboard-layers-geo-control.component';
import {
  DashboardUnitLayersGeoControlComponent
} from '../dashboard/monitoring/dashboard-layers-control/dashboard-unit-layers-geo-control/dashboard-unit-layers-geo-control.component';
import {
  DescriptionCardInfoItemComponent
} from './card-view/description-card-info/description-card-info-item/description-card-info-item.component';
import {
  SubscriptionPurchaseLogActionRenderComponent
} from '../subscription/subscription-purchase-list/subscription-purchase-log-action-render/subscription-purchase-log-action-render.component';
import {EndUserOrderPaymentItemComponent} from './card-view/payment/end-user-order-payment-item/end-user-order-payment-item.component';
import {
  EndUserOrderDebtPenaltyCommentComponent
} from './card-view/payment/end-user-order-debt-penalty-comment/end-user-order-debt-penalty-comment.component';
import {EndUserOrderDebtCardsComponent} from './card-view/payment/end-user-order-debt-cards/end-user-order-debt-cards.component';
import {StatisticSelectionComponent} from '../statistic/statistic-selection/statistic-selection.component';
import {ChargeStatusRenderComponent} from './grid-render-components/charge-status-render/charge-status-render.component';
import {UnitQrCodeComponent} from './unit-qr-code/unit-qr-code.component';
import {QRCodeModule} from 'angularx-qrcode';
import {IndicatorsViewComponent} from './card-view/indicators-view/indicators-view.component';
import {StatusesViewComponent} from './card-view/statuses-view/statuses-view.component';
import {
  BalancePackagePurchaseActionRendererComponent
} from './grid-render-components/balance-package-purchase-action-column-renderer/balance-package-purchase-action-renderer.component';
import {UnitCardIndicatorsComponent} from '../unit-card/unit-card-indicators/unit-card-indicators.component';
import {CardViewTabComponent} from './card-view/card-view-tab/card-view-tab.component';
import {ProfileStatusAvatarComponent} from './card-view/profile-status-avatar/profile-status-avatar.component';
import {
  SwiperInteractionButtonsComponent
} from './card-view/base-interaction-buttons/swiper-interaction-buttons/swiper-interaction-buttons.component';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {BaseExecuteViewComponent} from '../executor/view/base-execute-view.component';
import {ExecutorInteractionButtonsComponent} from '../executor/view/executor-interaction-buttons/executor-interaction-buttons.component';
import {ExecutorInfoComponent} from '../executor/view/executor-info/executor-info.component';
import {
  EmployeeMethodRegistrationFormComponent
} from '../base-employee/view/employee-method-registration-form/employee-method-registration-form.component';
import {ExecutorEmployeeInfoComponent} from '../executor/view/executor-emloyee-info/executor-employee-info.component';
import {ExecutorUnitListComponent} from '../executor/view/executor-unit-list/executor-unit-list.component';
import {ExecutorUnitListItemComponent} from '../executor/view/executor-unit-list-item/executor-unit-list-item.component';
import {AddUnitToExecutorComponent} from '../executor/view/add-unit-to-executor/add-unit-to-executor.component';
import {ViewInfoBlockComponent} from './card-view/view-info-block/view-info-block.component';
import {ModalWindowMessageComponent} from './modal-window/modal-window/modal-window-message/modal-window-message.component';
import {SwiperCardComponent} from './swiper/swiper-card/swiper-card.component';
import {SwiperCardInfoComponent} from './swiper/swiper-card-info/swiper-card-info.component';
import {SimpleDescriptionInfoComponent} from './card-view/simple-description-info/simple-description-info.component';
import {TranslationTabsComponent} from './translation-tabs/translation-tabs.component';
import {TranslationTabsItemComponent} from './translation-tabs/translation-tabs-item/translation-tabs-item.component';
import {PopupSelectionComponent} from './popup-selection/popup-selection.component';
import {StatisticBarComponent} from './statistic-bar/statistic-bar.component';
import {
  GeneralDescriptionCardInfoItemComponent
} from './card-view/general-description-card-info/general-description-card-info-item/general-description-card-info-item.component';
import {MapLatLngViewComponent} from './card-view/map-lat-lng-view/map-lat-lng-view.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {RatingCellComponent} from './grid-render-components/rating-cell/rating-cell.component';
import {RatingComponent} from './card-view/rating/rating.component';
import {SimpleCommentInfoComponent} from './card-view/simple-comment-info/simple-comment-info.component';
import {MapToolsMenuComponent} from './leaflet/map-tools-menu/map-tools-menu.component';
import {OnOffSwitcherComponent} from './card-view/on-off-switcher/on-off-switcher.component';
import {GeoWidgetComponent} from './geo-widget/geo-widget.component';
import {WeeklyScheduleComponent} from './card-view/weekly-schedule/weekly-schedule.component';
import {WeekDaysComponent} from './card-view/week-days/week-days.component';
import {HeatmapLegendComponent} from './map/controls/heatmap-legend/heatmap-legend.component';
import {
  DashboardLayersGeoObjectsControlComponent
} from '../dashboard/monitoring/dashboard-layers-control/dashboard-layers-geo-objects-control/dashboard-layers-geo-objects-control.component';
import {InfoTextComponent} from './info-text/info-text.component';
import {FilterMenuPopoverComponent} from './filter-menu-popover/filter-menu-popover.component';
import {UnitTypeFilterComponent} from './unit-type-filter/unit-type-filter.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function t(key: string): string {
  return _(key).toString();
}

@NgModule({
  declarations: [
//    FieldErrorComponent,
//    HelpIconComponent,
//    MustMatchDirective
    MapWidgetComponent,
    HeaderWithIconComponent,
    PreloaderComponent,
    FilterMenuPopoverComponent,
    UnitTypeFilterComponent,
    DateIntervalSelectionComponent,
    DateIntervalComponent,
    HorizontalItemSelectionComponent,
    HorizontalStackedBarChartComponent,
    DotLegendComponent,
    MapWidgetComponent,
    OutsideClickDirective,
    ModalWindowMessageComponent,
    ModalWindowLowBalanceComponent,
    ModalWindowConfirmationComponent,
    ModalWindowSelectionComponent,
    ModalWindowButtonSelectionComponent,
    ModalWindowChecklistComponent,
    ModalWindowQrcodeSizeComponent,
    TooltipDirective,
    InfoTextComponent,
    UserSelectionComponent,
    LeafletInfoControlComponent,
    LeafletMarkerGroupingToggleControlComponent,
    LeafletRegionsControlComponent,
    MapSettingsComponent,
    MapServicesComponent,
    DashboardLayersGeoControlComponent,
    DashboardLayersGeoObjectsControlComponent,
    DashboardUnitLayersGeoControlComponent,
    GeoitemToggleComponent,
    DescriptionCardInfoItemComponent,
    SubscriptionPurchaseLogActionRenderComponent,
    EndUserOrderPaymentItemComponent,
    EndUserOrderDebtPenaltyCommentComponent,
    EndUserOrderDebtCardsComponent,
    StatisticSelectionComponent,
    SubscriptionPurchaseLogActionRenderComponent,
    ChargeStatusRenderComponent,
    UnitQrCodeComponent,
    IndicatorsViewComponent,
    StatusesViewComponent,
    BalancePackagePurchaseActionRendererComponent,
    UnitCardIndicatorsComponent,
    CardViewTabComponent,
    ProfileStatusAvatarComponent,
    SwiperInteractionButtonsComponent,
    BaseExecuteViewComponent,
    ExecutorInteractionButtonsComponent,
    ExecutorInfoComponent,
    EmployeeMethodRegistrationFormComponent,
    ExecutorEmployeeInfoComponent,
    ExecutorUnitListComponent,
    ExecutorUnitListItemComponent,
    AddUnitToExecutorComponent,
    ViewInfoBlockComponent,
    SwiperCardComponent,
    SwiperCardInfoComponent,
    SimpleDescriptionInfoComponent,
    TranslationTabsComponent,
    TranslationTabsItemComponent,
    PopupSelectionComponent,
    StatisticBarComponent,
    GeneralDescriptionCardInfoItemComponent,
    MapLatLngViewComponent,
    RatingCellComponent,
    RatingComponent,
    SimpleCommentInfoComponent,
    MapToolsMenuComponent,
    OnOffSwitcherComponent,
    GeoWidgetComponent,
    WeeklyScheduleComponent,
    WeekDaysComponent,
    HeatmapLegendComponent
  ],
  imports: [
    CommonModule,
    SatPopoverModule,
    FormsModule,
    ReactiveFormsModule,

    NgxMaskModule.forRoot(),
    NgSelectModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    SimpleNotificationsModule,
    ResizableModule,

    TranslateModule,

    TimeagoModule.forChild({
      intl: {
        provide: TimeagoIntl,
        useFactory: (localeId) => {
          switch (localeId) {
            case 'ru-RU':
              return new TimeAgoIntlRu();
            default:
              return new TimeAgoIntlEn();
          }
        },
        deps: [LOCALE_ID]
      },
      formatter: {provide: TimeagoFormatter, useClass: TimeagoCustomFormatter, deps: [TimeagoIntl]},
    }),
    LightboxModule,
    RouterModule,
    QRCodeModule,
    SwiperModule,
    LeafletModule,
  ],
  exports: [
    FormsModule,
    SatPopoverModule,
    TranslateModule,
    ReactiveFormsModule,

    NgxMaskModule,
    NgSelectModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    ResizableModule,
    MapWidgetComponent,
    TimeagoModule,
    LightboxModule,
    PreloaderComponent,
    FilterMenuPopoverComponent,
    UnitTypeFilterComponent,
    DateIntervalSelectionComponent,
    HorizontalItemSelectionComponent,
    HorizontalStackedBarChartComponent,
    DotLegendComponent,
    OutsideClickDirective,
    ModalWindowMessageComponent,
    ModalWindowLowBalanceComponent,
    ModalWindowConfirmationComponent,
    ModalWindowSelectionComponent,
    ModalWindowButtonSelectionComponent,
    ModalWindowChecklistComponent,
    ModalWindowQrcodeSizeComponent,
    TooltipDirective,
    InfoTextComponent,
    UserSelectionComponent,
    DateIntervalComponent,
    LeafletInfoControlComponent,
    LeafletMarkerGroupingToggleControlComponent,
    LeafletRegionsControlComponent,
    MapSettingsComponent,
    MapServicesComponent,
    DashboardLayersGeoControlComponent,
    DashboardLayersGeoObjectsControlComponent,
    DashboardUnitLayersGeoControlComponent,
    GeoitemToggleComponent,
    DescriptionCardInfoItemComponent,
    SubscriptionPurchaseLogActionRenderComponent,
    EndUserOrderPaymentItemComponent,
    EndUserOrderDebtPenaltyCommentComponent,
    EndUserOrderDebtCardsComponent,
    StatisticSelectionComponent,
    SubscriptionPurchaseLogActionRenderComponent,
    ChargeStatusRenderComponent,
    UnitQrCodeComponent,
    IndicatorsViewComponent,
    StatusesViewComponent,
    BalancePackagePurchaseActionRendererComponent,
    UnitCardIndicatorsComponent,
    CardViewTabComponent,
    ProfileStatusAvatarComponent,
    SwiperInteractionButtonsComponent,
    BaseExecuteViewComponent,
    ExecutorInteractionButtonsComponent,
    ExecutorInfoComponent,
    EmployeeMethodRegistrationFormComponent,
    ExecutorEmployeeInfoComponent,
    ExecutorUnitListComponent,
    ExecutorUnitListItemComponent,
    AddUnitToExecutorComponent,
    ViewInfoBlockComponent,
    SwiperCardComponent,
    SwiperCardInfoComponent,
    SimpleDescriptionInfoComponent,
    TranslationTabsComponent,
    PopupSelectionComponent,
    StatisticBarComponent,
    GeneralDescriptionCardInfoItemComponent,
    MapLatLngViewComponent,
    RatingCellComponent,
    RatingComponent,
    SimpleCommentInfoComponent,
    MapToolsMenuComponent,
    OnOffSwitcherComponent,
    GeoWidgetComponent,
    WeeklyScheduleComponent,
    HeatmapLegendComponent
//    HelpIconComponent,
//    MustMatchDirective,


  ],
  providers: [
    {provide: OwlDateTimeIntl, useClass: DefaultIntl},
  ],
  entryComponents: [
    HeaderWithIconComponent,
    SubscriptionPurchaseLogActionRenderComponent,
    ChargeStatusRenderComponent,
    BalancePackagePurchaseActionRendererComponent,
    RatingCellComponent
  ]
})
export class SharedModule {
  constructor(
    private translateService: TranslateService,
    private translationSelectorService: TranslationSelectorService,
  ) {
    const language = this.translationSelectorService.getSelectedLanguage();
    translateService.setDefaultLang('en');
    translateService.use(language);
  }
}

